import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import Rent from '../screens/Rent';
import Success from '../screens/Success';

const _redirectRoute = { path: '*', element: <Navigate to="/" /> };

const guestRoutes = [
    { path: '/', element: <Rent /> },
    { path: '/success', element: <Success /> },
    _redirectRoute,
];

const routes = createBrowserRouter(guestRoutes);

const Routing = () => {
    return <RouterProvider router={routes} />;
};

export default Routing;
